import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldSchema, StringFieldOption } from '@lsq-frontend/remote-services/ar-app';
import { AbstractField } from '../dr-abstract-field/dr-abstract-field';

@Component({
    selector: 'dr-string-field',
    styleUrls: ['./dr-string-field.component.scss'],
    templateUrl: './dr-string-field.component.html'
})
export class StringField extends AbstractField {
    @Input() fieldSchema: FieldSchema;
    @Input() field: { fieldValue?: any };
    @Input() formGroup: FormGroup;
    @Input() reviewMode = false;
    public FieldTypeEnum = FieldSchema.FieldTypeEnum;

    public isReadOnly(): boolean {
        return this.fieldSchema.isReadOnly;
    }

    public transformType(type: string): string {
        return type?.toLowerCase();
    }

    public getMask() {
        const fieldOption: StringFieldOption = this.fieldSchema?.fieldOption;
        if (
            fieldOption?.inputType === StringFieldOption.InputTypeEnum.Tel ||
            fieldOption?.inputType === StringFieldOption.InputTypeEnum.VerificationCode
        ) {
            return fieldOption.mask;
        } else {
            return '';
        }
    }
}
